<template>
  <div class="report-section report-section-footer">
    <p>{{ reportData.company }}</p>
    <p style="margin-top: 5px;">{{ reportData.copyright }}</p>
  </div>
</template>

<script>
export default {
  name: 'ReportFooter',
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="less" scoped>
.report-section-footer {
  background: #f7f8fa;
  padding: 20px 40px;
  border-top: 1px solid #e5e6eb;
  // box-shadow: 10px 0 12px -8px rgba(0, 0, 0, 0.08),
  //   0 10px 12px -8px rgba(0, 0, 0, 0.08),
  //   -10px 0 12px -8px rgba(0, 0, 0, 0.08);

  p {
    color: #86909c;
    font-size: 13px;
    line-height: 1.6;
    text-align: center;
  }
}
</style>
